module.exports = __webpack_public_path__ + "static/img/CITROEN.4559eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/CITROEN.png
// module id = tG/o
// module chunks = 1